import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { MarketingCampaign } from "../../marketing.types";
import { requestGetMarketingCampaign } from "./getMarketingCampaign.request";

const useMarketingCampaign = (
  campaignId: string,
  options?: QueryOptions<MarketingCampaign, ApiServiceError<ApiError>>
) => {
  const { data: campaign, ...rest } = useQuery({
    queryKey: ["marketing", "campaigns", "detail", campaignId],
    queryFn: async () => await requestGetMarketingCampaign(campaignId),
    onError: toastServerError,
    enabled: Boolean(campaignId),
    ...options
  });

  return { campaign, ...rest };
};

export default useMarketingCampaign;
